<template>
  <div class="areaText">
    <img class="img" v-lazy="$config.imgIp + graphic.logo" align="right" />
    <div class="infos" v-html="graphic.qyjs"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["graphic"])
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.areaText
  padding-right 5px
  height 100%
  overflow-y auto
  .img
    height 150px
    border-radius 10px
    padding-left 5px
  .infos
    text-indent 2em
    line-height 26px
    letter-spacing 2px
    color #fff !important
.areaText
  overflow auto
  &::-webkit-scrollbar
    width 3px
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color $textColor
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
@media (max-width 1280px)
  .areaText
    .img
      height 75px
    .infos
      line-height 20px
      >>>p
        font-size 0.08rem !important
</style>
<style lang="stylus">
.info p
  color #fff !important
</style>
